import {
  Row,
  Skeleton,
  Typography,
  VertBreadcrumb,
  VertContainer,
  VertIcon,
} from '@vertem-core/vertice-ds';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import { SpotInfos } from './components/spotInfos';
import { SpotSupplierInfo } from './components/spotSupplierInfo';
import { SpotHistory } from './components/spotHistory';

import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import SpotOrcament from './components/spotOrcament';
import SpotTerms from './components/spotTerms';
import ModalSendDocument from './components/ModalSendDocument';
import { RightOutlined } from '@ant-design/icons';
import {
  loadDataQuote,
  loadUserQuote,
} from 'redux/Reducers/Quotation/ApproveQuotation';
import { SpotAdressQuote } from './components/SpotAdressQuote';
import { closeModal as closeBalloon, openModal as openBalloon } from "../../redux/Reducers/PopBallon/VertemGiftSlice";
import BalloonModal from "../../components/PopBallon/ShowcasePopBallon/BallonModal";
import { fetchAvailableBallons } from "../../redux/Reducers/PopBallon/VertemGiftApi";
import { SpotNotFound } from 'components/Spot/SpotNotFound';

let checkBallonGet = false
const ApproveQuote = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [quote, setQuote] = useState(null);
  const [allowBalloon, setAllowBalloon] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleModalDocument, setIsVisibleModalDocument] = useState(false);
  const [loadingHasPermission, setLoadinHasPermission] = useState(true);
  const dispatch = useDispatch();
  const [isLoadingBalloonFetch, setIsLoadingBalloonFetch] = useState(true)
  const [productsIds, setProductsIds] = useState([]);
  const [error, setError] = useState(false);
  const [termDownloadUrl, setTermDownloadUrl] = useState(null);
  const { isPMO, isManager, isLead, getRedemptionSpotGroups } =
    useParticipantSubSegment();
  const { isModalOpen, availableBallons, isLoaded } = useSelector(({ VertemGift }) => VertemGift)
  const [isErrorsForm, setIsErrorsForm] = useState(false);

  const validGroup = getRedemptionSpotGroups();
  const [modalDocument, setModalDocument] = useState({
    type: 1,
    url: null,
  });
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const {
    dataSpot: spot,
    quote: customQuote,
    isErrorSpot,
    isLoadingSpot: isLoadingSpotReducer,
  } = useSelector((state) => state.ApproveQuotation);

  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];
  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };

  const participantId = userProfile['custom:participant_id'];

  const handleModalClose = () => {
    dispatch(closeBalloon());
  }

  const handleModalShow = () => {
    dispatch(openBalloon());
  }


  useEffect(() => {
    if (userInfos?.isLoaded) {
      dispatch(
        loadDataQuote({
          redemptionId: params.id,
          headers: config,
        })
      );
    }
  }, [userInfos]);

  useEffect(() => {
    setIsLoading(isLoadingSpotReducer);
  }, [isLoadingSpotReducer]);

  useEffect(() => {
    let _quote = customQuote;
    if (
      spot?.redemptionStatusId > 2 &&
      spot?.redemptionStatusId !== 5 &&
      spot?.type !== 4
    ) {
      _quote = spot?.files.find((x) => x.approved === true);
    }

    setQuote(_quote);
  }, [spot]);

  useEffect(() => {
    if (!spot) {
      setLoadinHasPermission(false);
      return;
    }

    if (spot.participantId && participantId) {
      const isAccessParticipant = String(spot.participantId) === participantId;

      const hasAccess = isPMO || isLead || isManager || isAccessParticipant;

      if (!hasAccess) {
        setError(true);
      } else {
        setLoadinHasPermission(true);
      }
    }
  }, [spot, isPMO, isLead, isManager, spot?.participantId, participantId]);

  useEffect(() => {
    if (spot !== null && !isLoadingSpotReducer && spot.id) {
      handleSetTermDownloadUrl(spot);
      if (
        spot.redemptionStatusId === 3 ||
        (spot.type === 3 && spot.redemptionStatusId === 4)
      ) {
        dispatch(
          loadUserQuote({
            participantId: spot?.participantId,
            headers: config,
          })
        );
      }
    }
  }, [spot, isLoadingSpotReducer, spot.id]);

  const handleSetTermDownloadUrl = (spot) => {
    if (spot.redemptionStatusId === 4) {
      const { url } = spot.files.find((f) => f.type === 2 && f.status === 1);
      setTermDownloadUrl(url);
    }
  };

  const callModalDocuments = (type, document) => {
    setModalDocument({ type, url: document });
    setIsVisibleModalDocument(true);
  };

  const getSpotTypeDescription = () => {
    if ((isPMO || isLead) && spot && spot.type === 2) return 'SPOT HIERARQUIA';

    if (spot && spot.type === 4) return 'COTAÇÃO';

    return 'SPOT';
  };

  const breadcrumbMock = [
    {
      title: 'Início',
      path: '/',
    },
    {
      title: 'Lista de Solicitações',
      path: '/list-redemptions',
    },
    {
      title: `Solicitação #${params.id} - ${getSpotTypeDescription()}`,
      path: `/approve-redemption/${params.id}`,
    },
  ];

  useEffect(() => {
    if (!isVisibleModalDocument && allowBalloon && isLoaded) handleModalShow()
  }, [isVisibleModalDocument, allowBalloon, isLoaded]);

  const getBalloonsData = async () => {
    dispatch(fetchAvailableBallons());
    setIsLoadingBalloonFetch(false)
  }

  useEffect(() => {
    if (!isLoaded && !checkBallonGet) {
      checkBallonGet = true;
      getBalloonsData()
    }
  }, [isLoaded])

  return (
    <>
      <VertContainer spacingX="regular" spacingY="small">
        <Row className="extract-page-breadcrumb" align="middle" gutter={0}>
          <VertBreadcrumb hasBackButton={true}
            separator={<VertIcon component={RightOutlined} />}
            items={breadcrumbMock}
          />
        </Row>
      </VertContainer>

      {error || isErrorSpot ? (
        <SpotNotFound id={params.id} />
      ) : (
        <VertContainer fluid>
          {!loadingHasPermission || !spot || !spot.id ? (
            <VertContainer spacingX="regular" spacingY="small">
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </VertContainer>
          ) : (
            <VertContainer>
              <div className={'container-view-redemption'}>
                <VertContainer className="container-title-view-redemption">
                  <Typography.Text className="title-view-redemption">
                    Solicitação #{spot.id} - {getSpotTypeDescription()}
                  </Typography.Text>
                </VertContainer>
                <SpotInfos
                  spot={spot}
                  isManager={isPMO || isLead}
                  callModalDocuments={callModalDocuments}
                  isQuote={true}
                />
                <SpotSupplierInfo
                  spot={spot}
                  callModalDocuments={callModalDocuments}
                />

                <SpotHistory
                  histories={spot.histories}
                  isManager={isPMO || isLead}
                />
                <SpotOrcament
                  spot={spot}
                  quote={quote}
                  setQuote={setQuote}
                  callModalDocuments={callModalDocuments}
                  isPMO={isPMO}
                  isLead={isLead}
                  productsIds={productsIds}
                  setProductsIds={setProductsIds}
                />
                {spot.redemptionStatusId === 4 && (
                  <SpotAdressQuote
                    spot={spot}
                    isManager={isPMO || isLead}
                    isErrorsForm={isErrorsForm}
                    setIsErrorsForm={setIsErrorsForm}
                  />
                )}
                {spot &&
                  spot.products &&
                  spot.type === 4 &&
                  spot.redemptionStatusId === 4 && (
                    <SpotTerms
                      isErrorsForm={isErrorsForm}
                      spot={spot}
                      callModalDocuments={callModalDocuments}
                      isLoading={isLoading}
                      isPMO={isPMO}
                      participantId={participantId}
                      isLead={isLead}
                      quote={quote}
                      products={spot.products}
                      productsIds={productsIds}
                      termDownloadUrl={termDownloadUrl}
                    />
                  )}
              </div>
            </VertContainer>
          )}

          {(!isVisibleModalDocument && isModalOpen && allowBalloon && availableBallons && availableBallons.length && isLoaded && !isLoadingBalloonFetch) && (
            <BalloonModal
              balloon={availableBallons[0]}
              onClose={handleModalClose}
            />
          )}

          <ModalSendDocument
            isVisible={isVisibleModalDocument}
            setIsVisible={setIsVisibleModalDocument}
            spot={spot}
            document={modalDocument}
            isPMO={isPMO}
            isLead={isLead}
            modalDocument={modalDocument}
            callbackSuccess={() => {
              if (availableBallons && availableBallons.length) setAllowBalloon(true)
              setTimeout(() => {
                if (isVisibleModalDocument) {
                  setIsVisibleModalDocument(false)
                }
              }, 3000)
            }}
          />
        </VertContainer>
      )}
    </>
  );
};

export default ApproveQuote;
